import { Component, Inject, ViewChild } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Main } from '../core/main.service';
import { DrawService } from './draw.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxWheelComponent } from 'ngx-wheel';

@Component({
  selector: 'cp-draw',
  templateUrl: './draw.component.html',
  styleUrls: ['./draw.component.scss'],
})

export class DrawComponent {
  @ViewChild(NgxWheelComponent, { static: false }) wheel;

  items: any = [];
  idToLandOn: any;
  showTime: string = "";
  startingInHeader: string = "Drawing Starting in";
  showCountDown: boolean = true;
  seconds = 262017;
  id: string;
  members: any = [];
  winner: any = {};
  showWinner = false;
  showWheel: boolean = false;
  award: any = {};
  constructor(@Inject(Restangular) public Restangular, private mainService: Main, private route: ActivatedRoute, private api: DrawService) {
    if (this.route.queryParams['value']['id']) {
      this.id = this.route.queryParams['value']['id'];
      //this.getCategory();
    }
  }

  ngOnInit() {
    this.populateItems();
  }

  ngAfterViewInit() {
    this.overlayOn();
    this.getLatestAwardSchedule();
  }

  populateItems() {
    for (var i = 0; i < 70; i++) {
      //var color = '#a7a7a7';
      var color = '#3E2723';
      var orientation = 'vertical';
      if (i % 2 == 0) {
        color = '#553528'
      }
      if (this.members.length < 3) {
        orientation = 'horizontal'
      }
      this.items.push({ id: i + 1, text: (i + 1).toString(), fillStyle: color, 'textOrientation': 'vertical', 'lineWidth': 0.5, textFillStyle: '#ffffff', innerRadius: 10, 'textFontSize': 16, 'textFontWeight': 'normal', },)
    }
    /*   this.api.getEkubMembers(this.id).subscribe((res: any) => {
        debugger;
        if (res.users) {
          this.members = res.users;
           for (let i = 0; i < this.members.length; i++) {
             var color = '#3E2723';
             var orientation = 'vertical';
             if (i % 2 == 0) {
               color = '#AB6B51'
             }
             if (this.members.length < 3) {
               orientation = 'horizontal'
             }
             this.items.push({ id: i + 1, text: (i + 1).toString(), fillStyle: color, 'textOrientation': orientation, 'lineWidth': 0.5, textFillStyle: '#ffffff', innerRadius: 10, 'textFontSize': 16, 'textFontWeight': 'normal', },);
           }
           if (res.users.length > 0) {
             this.showWheel = true;
           }
        }
      }); */
  }

  reset() {
    // Reset allows you to redraw the wheel
    // Use it after any change to wheel configurations or to allow re-spinning
    this.wheel.reset();
  }

  async spin() {
    this.winner = this.items[Math.floor(Math.random() * this.items.length)];
    this.idToLandOn = this.winner.id;
    await new Promise(resolve => setTimeout(resolve, 0)); // Wait here for one tick
    this.wheel.spin();
  }

  before() {
    console.log("Before");
    this.reset();
  }

  after() {
    console.log("After");
    // TODO Change the winning color
    this.showWinner = true;
    //let winningSegmentNumber = this.wheel.getIndicatedSegmentNumber();
    //this.wheel.segments[winningSegmentNumber].fillStyle = '#89f26e';
    // TODO save winner this.saveWinner();
  }

  saveWinner() {
    debugger;
    this.award.satatus = "drawn";
    this.award.winner_id = this.winner.id;
    this.api.saveWinner(this.award, this.award.id).subscribe((res: any) => {
      debugger;
      console.log(res);
    }, (err) => {
      debugger;
      console.log(err);
      //this.mainService.toast({ title: 'Error', body: err.statusText, type: 'danger' });
    });

  }
  overlayOff() {
    document.getElementById("overlay").style.display = "none";

  }

  overlayOn() {
  //  document.getElementById("overlay").style.display = "block";
  }


  getLatestAwardSchedule() {
    this.api.getLatestAward(this.id).subscribe((res: any) => {
      debugger;
      this.award = res.award;
      this.convertTime(this.award.draw_date);
      //setInterval(this.convertTime, 1000,this.seconds);
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'danger' });

    });

  }

  convertTime(drawDate: string) {

    // var awardDate = DateTime.parse('2021-08-13 19:21:00');

    var today = new Date();
    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var todayDateTime = date + ' ' + time;
    console.log("Today: " + todayDateTime);

    var startDate = new Date(todayDateTime);
    //var endDate = new Date("2021-08-22 03:05:00");
    var endDate = new Date(drawDate);

    console.log("endDate" + endDate);
    var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
    console.log("Date difference in seconds is: " + seconds);
    this.seconds = seconds;

    var interval = setInterval(() => {
      var seconds = this.seconds;
      let dayTime = (60 * 60 * 24)
      var day = Math.floor(seconds / dayTime)
      let rmainingTime = (seconds - (dayTime * day));
      let hoursTime = (60 * 60);
      var hour = Math.floor(rmainingTime / (hoursTime))
      rmainingTime = (rmainingTime - (hoursTime * hour));
      let minTime = 60;
      var minute = Math.floor(rmainingTime / minTime)
      rmainingTime = (rmainingTime - (minTime * minute));
      var second = Math.floor(rmainingTime)
      this.seconds--;
      console.log('Day - ' + day + ', Hours - ' + hour + ', Minutes - ' + minute + ', Seconds - ' + second);
      if (day > 1) {
        this.showTime = new Date(drawDate).toDateString();
      } else {
        this.showTime = ((day != 0) ? (day + ':') : "") + ((hour != 0) ? ((hour < 10) ? "0" + hour : hour) + ':' : "") + ((minute < 10) ? "0" + minute : minute) + ':' + ((second < 10) ? "0" + second : second);
      }
      if (day == 0 && hour == 0 && minute == 0 && second == 0) {
        this.overlayOff();
        this.spin();
      }
      if (day < 0) {
        this.startingInHeader = "Already Drawn"
        this.showCountDown = false;
      }
    }, 1000);
  }
}
